import { getApiErrorDetail, getApiErrorStatus } from './apiErrorUtils';

export const ACCESS_DENIED_DETAIL = 'You do not have permission to view this EPD.';
export const OWNER_ONLY_DETAIL = 'Only the EPD Owner is allowed to perform this action.';

const WRITE_BLOCKED_STATUSES = [404, 409];

/**
 * The server's message when a write was refused because the EPD cannot be written:
 * 409 (company locked, Read-only EPD) or 404 (unknown or Hidden EPD).
 * Returns null for any other status, or when the answer carries no detail.
 */
export const getEpdWriteBlockedMessage = (error: unknown): string | null => {
  const status = getApiErrorStatus(error);

  if (status === undefined || !WRITE_BLOCKED_STATUSES.includes(status)) {
    return null;
  }

  return getApiErrorDetail(error) ?? null;
};

export const getEpdActionErrorMessage = (error: unknown): string | null => {
  const writeBlockedMessage = getEpdWriteBlockedMessage(error);

  if (writeBlockedMessage) {
    return writeBlockedMessage;
  }

  const status = getApiErrorStatus(error);

  if (status !== 403) {
    return null;
  }

  const detail = getApiErrorDetail(error);

  if (detail === ACCESS_DENIED_DETAIL) {
    return ACCESS_DENIED_DETAIL;
  }

  return detail ?? OWNER_ONLY_DETAIL;
};
